//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Direccion from '@/api/promotores/usuarios/direcciones.api'
export default {
  props: {
    promotorId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loading: false,
      saving: false,
      direccion: {}
    }
  },

  computed: {
    direccion_completa() {
      if (Object.keys(this.direccion).length === 0) {
        return null
      }
      
      return [
        [this.direccion.calle, this.direccion.numero].join(" "),
        this.direccion.colonia,
        this.direccion.delegacion,
        [this.direccion.codigo_postal, this.direccion.entidad].join(" "),
      ].join(", ");
    },
    linkToGMaps() {
      return this.direccion_completa ? `https://www.google.com/maps/place/${this.direccion_completa}` : null
    },
  },

  methods: {
    show() {
      this.$refs.dialog.show()
      this.loadDireccion()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    async loadDireccion() {
      try {
        this.loading = true
        this.direccion = await Direccion.get(this.promotorId)
      } finally {
        this.loading = false
      }
    },
    async submit() {
      try {
        this.saving = true
        
        const response = this.direccion.id 
          ? await Direccion.update(this.promotorId, this.direccion)
          : await Direccion.create(this.promotorId, this.direccion)

        this.$emit("ok", response);
        this.hide();
      } finally {
        this.saving = false
      }
    }
  }
}
